export default __webpack_public_path__ + "static/media/new-tab-w.1fd6b655.svg";